import React from 'react';
import styled, { css } from 'styled-components';

import { DetailedCarTitleLinksProps } from '@/components/DetailedCarTitleLinks/DetailedCarTitleLinks.types';
import Link from '@/components/Link';
import { colors } from '@/constants/theme';
import { useIsHideLayout } from '@/hooks/useIsHideLayout';

function DetailedCarTitleLinks({
  links,
  isMobile,
}: DetailedCarTitleLinksProps) {
  const isHideLayout = useIsHideLayout();

  if (isHideLayout) {
    return null;
  }

  return (
    <Component>
      <LinksWrapper>
        {links.map((item, index) => {
          return (
            <Links key={index} to={item.url} isMobile={!!isMobile}>
              {item.label}
            </Links>
          );
        })}
      </LinksWrapper>
    </Component>
  );
}

export default DetailedCarTitleLinks;

const Component = styled.div`
  position: relative;
  overflow: hidden;
`;

const LinksWrapper = styled.div`
  white-space: nowrap;

  &::after {
    content: '';
    background: ${(props) => props.theme.whiteGradient_1};
    right: 0;
    top: 0;
    bottom: 0;
    width: 147px;
    height: 100%;
    display: block;
    position: absolute;
    pointer-events: none;
  }
`;

const Links = styled(Link)<{ isMobile: boolean }>`
  font-size: 18px;
  color: ${(props) => props.theme.black};

  &:not(:last-child) {
    font-weight: 300;
    margin-right: 10px;

    &::after {
      content: ' / ';
      margin-left: 15px;
    }
  }

  &:hover {
    color: ${colors.main};
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      font-size: 16px;
    `}
`;
